import { supabase } from '@/integrations/supabase/client';
import type { Organization } from '../types/organization.types';

export const organizationRepository = {
  /**
   * Calls the database function to retrieve the active organization ID for current session.
   */
  async getCurrentUserOrganizationId(): Promise<string | null> {
    const { data, error } = await supabase.rpc('get_current_user_organization_id');
    if (error) {
      console.error('Error getting current organization ID:', error);
      return null;
    }
    return data ?? null;
  },

  /**
   * Fetches an organization by ID.
   */
  async getOrganizationById(orgId: string): Promise<Organization | null> {
    const { data, error } = await supabase
      .from('organizations')
      .select('*')
      .eq('id', orgId)
      .single();

    if (error) {
      console.error('Error fetching organization by ID:', error);
      return null;
    }

    return (data as unknown) as Organization;
  },

  /**
   * Updates organization settings.
   */
  async updateOrganization(
    orgId: string,
    updates: Partial<Pick<Organization, 'name' | 'slug' | 'settings' | 'organization_type' | 'logo_url'>>
  ): Promise<Organization> {
    const { data, error } = await supabase
      .from('organizations')
      .update(updates)
      .eq('id', orgId)
      .select()
      .single();

    if (error) {
      console.error('Error updating organization:', error);
      throw error;
    }

    return (data as unknown) as Organization;
  },
};
